<template>
  <div id="offer">
    <SearchScreen @search="handleSearch"/>

    <div id="search-data" class="screen" v-if="isSearch">
      <ProductsList :productsProps="searchData" v-if="true"/>
      <span v-if="!searchData">Nc nie znaleziono</span>
    </div>

    <div id="offer-category-grid" class="screen" v-if="!category && !isSearch">
      <CategoryGrid :offerData="offerData"/>
    </div>

    <ProductsList :category="category" v-if="category && !isSearch"/>

    <ContactScreenContainer :contact-data="contactData"/>

    <div id="footer" class="screen">
      <span>Copyright &copy; 2019 Dach-Bud GRUDZIĄDZ</span>
    </div>
  </div>
</template>

<script>
import SearchScreen from '@/components/OfferView/SearchScreen.vue';
import CategoryGrid from '@/components/OfferScreen/CategoryGrid.vue';
import ContactScreenContainer from '@/components/ContactScreen/ContactScreenContainer.vue';
import ProductsList from '@/components/OfferScreen/ProductsList.vue';

import axios from 'axios';

const API = require('../api.json').api_v1;


export default {
  name: 'Offer.vue',
  components: {
    ProductsList,
    ContactScreenContainer,
    CategoryGrid,
    SearchScreen,
  },
  data() {
    return {
      category: null,
      offer: true,
      isSearch: false,
      searchData: [
        {
          id: null,
          category_id: null,
          name: '',
          description: '',
          image: 'placeholder',
        },
      ],
      menuContent: null,
      offerData: [{ id: null, image: '', title: '' }],
      contactData: {
        id: null,
        address_1: '',
        address_2: '',
        town_and_code: '',
        info: '',
        fax: '',
        phone_num: '',
        email: '',
        opening_hours: '',
      },
    };
  },
  methods: {
    async getCategories() {
      let response = await axios.get(`${API}/categories`);
      response = response.data.data;
      const result = [];

      for (let i = 0; i < response.length; i++) {
        result[i] = {
          id: response[i].id,
          title: response[i].name,
          image: `${API}/categories/images/${response[i].image}`,
        };
      }
      return result;
    },
    async getFromAPI(query) {
      const result = await axios.get(`${API}/${query}`);
      return result.data.data;
    },

    async handleSearch(value) {
      if (value.is) {
        const s = value.value.replace(' ', '_');
        if (s.length > 2) {
          this.isSearch = value.is;
          let response = await axios.get(`${API}/search?q=${s}`);
          response = response.data.data;
          const result = [];

          for (let i = 0; i < response.length; i++) {
            result[i] = {
              id: response[i].id,
              category_id: response[i].category_id,
              name: response[i].name,
              description: response[i].description,
              image: '',
            };

            if (response[i].image === 'placeholder') {
              result[i].image = 'placeholder';
            } else {
              result[i].image = `${API}/products/images/${response[i].image}`;
            }
          }
          this.searchData = result;
        } else {
          this.isSearch = false;
          this.searchData = [];
        }
      }
    },
  },
  mounted() {
    this.category = this.$route.params.category;
    window.scrollTo(0, 0);
  },
  async created() {
    this.$emit('offer', true);
    this.offerData = await this.getCategories();
    this.contactData = await this.getFromAPI('contact');
  },
  destroyed() {
    this.$emit('offer', false);
  },
  watch: {
    '$route.params.category': async function () {
      this.category = this.$route.params.category;
      function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
      }

      let toTop = window.scrollY;
      while (toTop > 0) {
        window.scrollTo(0, toTop);
        toTop -= 35;
        // eslint-disable-next-line no-await-in-loop
        await sleep(5);
      }
    },
  },
};
</script>

<style scoped lang="scss">
  #offer {
    background-color: white;
    margin-top: 50px;
    color: black;
    min-height: 100vh;
  }

  #search-screen {
    p {
      padding: 0;
    }
  }
</style>
